type TransformedUpdateType<T> = {
  [K in keyof T]: { set: T[K] };
};

export const transformToUpdate = <T extends Record<string, unknown>>(
  obj: T
): TransformedUpdateType<T> => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, { set: value }])
  ) as TransformedUpdateType<T>;
};
